import { GOOGLE_ID } from "./constants";

export const loadGA = () => {
  window.dataLayer = window.dataLayer || [];
  function gtag() {
    window.dataLayer.push(arguments);
  }
  gtag("js", new Date());
  gtag("config", GOOGLE_ID);

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ID}`;
  script.async = true;
  document.head.appendChild(script);

  console.log("Google Analytics loaded");
};

export const removeGA = () => {
  // Remove the GA loader script
  const gaScript = document.querySelector(
    `script[src*="googletagmanager.com/gtag/js"]`
  );
  if (gaScript) gaScript.remove();

  // Remove any inline GA script if present
  const inlineScripts = Array.from(document.querySelectorAll("script")).filter(
    (script) => script.innerText.includes("gtag")
  );
  inlineScripts.forEach((script) => script.remove());

  window.gtag = function () {
    console.warn("Tracking blocked: Consent revoked.");
  };

  console.log("Google Analytics removed");
};
